import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLastSplittedStringItem, getRelativeDocumentUrl } from "../../src/taskpane/components/helpers/stringHelper";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { CommandBar, ICommandBarItemProps, ICommandBarStyles, ConstrainMode, DetailsListLayoutMode, IColumn, IGroup, mergeStyleSets, ScrollablePane, ScrollbarVisibility, Selection, SelectionMode, ShimmeredDetailsList, TooltipHost, Icon, Label, Link, Dialog, DialogFooter, PrimaryButton, DialogType, IContextualMenuItem, Spinner, SpinnerSize, IIconProps, IDetailsListProps, DetailsHeader, Stack, FontIcon, IStackTokens, DetailsRow, ISpinnerStyles, } from "@fluentui/react";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { IPageSettings } from "../../src/taskpane/interfaces/IPageSettings";
import { addWorkingDirectory, removeDirectoriesByIndexAndAddItem } from "../../src/taskpane/redux/modules/workingDirectory";
import { getItemCustomSelect, getSharePointSiteFromDriveId, getTeamChannelInfo, getTeamChannelRelatedSitesInfo } from "../../src/taskpane/services/GraphService";
import authModule from "../../utilities/AuthModule";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { getLocationDocumentLibraries, getLocationSharepointLists, getLocationSubSites, getLocationTeamChannels, getLocationTessProjectLibrariesAndFolders, getLocationTessProjects, ILocation, ISharepointFolderLocation, ISharepointListLocation, ITeamChannelLocation, ITessProjectLocation, LocationType } from "../Services/LocationService";
import { gridSelectedItems } from "./ContentManagerBody";
import { DocLibraryIcon } from "@fluentui/react-icons-mdl2"
import { addPinnedItem, isFolderPinned, removePinnedItem } from "../../src/taskpane/redux/modules/pinnedItems";
import { ITeamChannelDocumentLibrary } from "../../src/taskpane/interfaces/services/ITeamChannelDocumentLibrary";
import { FileTypeEnum } from "../../src/taskpane/components/enums/fileTypeEnum";
import { FolderTypeIconEnum } from "../../src/taskpane/components/enums/FolderTypeIconEnum";
import { IStoreItem } from "../../src/taskpane/interfaces/IStoredItem";
import { CMFAdvancedSearchPanel } from "../Panels/CMFAdvancedSearchPanel";
import { detailRowLinkStyles } from "../../src/taskpane/config/controlStyles";
import { setIsContentManagerContentLoading } from "../../src/taskpane/redux/modules/contentManagerDirectory";
import { documentLibraryItem, SiteItem } from "../../src/taskpane/redux/models/reduxModels";
import { CMPermissionsPanel } from "../Panels/CMPermissionsPanel";
import { logger } from "../../utilities/logger";
import { gridFontIconStyles } from "../../src/taskpane/styles/iconStyles";
import { FileIconType, getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { displayHeight, SharePointFolderContentTypeIds } from "../../src/taskpane/config/constants";
import { DraggableContainer } from "../../src/taskpane/components/_v2/components/Explorer/FolderView/DraggableContainer";
import generalModule from "../../utilities/GeneralModule";
import { ChannelShareIcon } from "../../src/taskpane/components/_v2/components/SvgIcons/ChannelShareIcon";
import { ChannelPrivateIcon } from "../../src/taskpane/components/_v2/components/SvgIcons/ChannelPrivateIcon";
import { getLists } from "../../src/taskpane/services/SharePointRestServices";
import { IListInfo } from "@pnp/sp/lists/types";
import { TessProjectStatusEnum } from "../../src/taskpane/services/TessService";
import { IHit } from "../../src/taskpane/interfaces/IGraphSearchQueryResult";
import { tryGetSiteRelativeUrl } from "../../src/taskpane/components/helpers/UrlHelper";
import { tryDecodeUriComponent } from "../../utilities/EncodeDecode";
import { CancellableSharePointRestApi } from "../../src/taskpane/services/CancellableSharePointRestApi";

const classNames = mergeStyleSets({
    wrapper: {
        height: displayHeight,
        position: "relative",
    },
    svgIcon: {
        fontSize: 18
    }
});

const openInBrowserIconProps: IIconProps = { iconName: "SharepointLogo" };
const unpinIconProps: IIconProps = { iconName: "Unpin" };
const pinIconProps: IIconProps = { iconName: "Pin" };
// const advancedSearchIconProps: IIconProps = { iconName: "SearchData" };
const refreshIconProps: IIconProps = { iconName: "Refresh" };
const permissionsIconProps: IIconProps = { iconName: "Permissions" };

const commandBarStyle: Partial<ICommandBarStyles> = {
    root: {
        borderTop: '1px solid rgb(237, 235, 233);',
        borderBottom: '1px solid rgb(237, 235, 233);',
        paddingLeft: 0,
        paddingRight: 10,
        paddingBottom: 3,
        paddingTop: 3
    }
};

const gridLinkStackTokens: IStackTokens = {
    childrenGap: 5
};

const rootLevelItemsSpinnerStyles: ISpinnerStyles = {
    root: {
        alignItems: "flex-start"
    }
}

function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey as keyof T;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
};

const _getKey = (item: any, index?: number): string => {
    return item?.key;
};

interface IContentBodyLibrariesProps {
}

export const ContentBodyLibraries: React.FunctionComponent<IContentBodyLibrariesProps> = ({

}: IContentBodyLibrariesProps) => {
    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();

    const workingDirectories = useSelector((state: RootState) => state.workingDirectories.workingDirectories);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const siteInfo = useSelector((state: RootState) => state.tenantInfo.sites);
    const allowedSites = useSelector((state: RootState) => state.tenantInfo?.allowedSiteCollections);
    const tenantEnablePermissionManagement = useSelector((state: RootState) => state.tenantInfo?.enablePermissionManagement);
    const hideDocumentLibrariesInTeams = useSelector((state: RootState) => state.tenantInfo?.hideDocumentLibrariesInTeams);
    const allowOpenInSharePoint = useSelector((state: RootState) => state.user.tenantAllowOpenInSharePoint ?? true);
    const pinnedItems = useSelector((state: RootState) => state.pinned?.pinnedItems);
    const isTessEnabled = useSelector((state: RootState) => state.tenantInfo?.isTessEnabled);

    const [refresh, setRefresh] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [isUploadingFiles, setIsUploadingFiles] = React.useState<boolean>(false);
    const [isTeamChannelInfoLoading, setIsTeamChannelInfoLoading] = React.useState<boolean>(false);

    const [commandItems, setCommandItems] = React.useState<ICommandBarItemProps[]>();
    const [commandFarItems, setCommandFarItems] = React.useState<ICommandBarItemProps[]>();
    const [columns, setColumns] = React.useState<IColumn[]>(null);
    const [groups, setGroups] = React.useState<IGroup[]>(null);

    const [hubAssociatedHubs, setHubAssociatedHubs] = React.useState<ILocation[]>([]);
    const [hubAssociatedSites, setHubAssociatedSites] = React.useState<ILocation[]>([]);
    const [subSites, setSubSites] = React.useState<ILocation[]>([]);
    const [channels, setChannels] = React.useState<ILocation[]>([]);
    const [documentLibraries, setDocumentLibraries] = React.useState<ILocation[]>([]);
    const [sharepointLists, setSharepointLists] = React.useState<ILocation[]>([]);
    const [tessActiveProjectSites, setTessActiveProjectSites] = React.useState<ITessProjectLocation[]>([]);
    const [tessDraftProjectSites, setTessDraftProjectSites] = React.useState<ITessProjectLocation[]>([]);
    const [tessFinishedProjectSites, setTessFinishedProjectSites] = React.useState<ITessProjectLocation[]>([]);
    const [tessProjectFolders, setTessProjectFolders] = React.useState<ILocation[]>([]);

    const [items, setItems] = React.useState<(ILocation | null)[] | undefined>(undefined);
    const [selectedLocation, setSelectedLocation] = React.useState<ILocation>();
    const [selectedItems, setSelectedItems] = React.useState<gridSelectedItems>({ items: [], count: 0 });
    const [selectedSharepointListId, setSelectedSharepointListId] = React.useState<string>();

    const [isAdvancedSearchPanelOpen, setIsAdvancedSearchPanelOpen] = React.useState<boolean>(false);
    const [isPermissionsPanelOpen, setIsPermissionsPanelOpen] = React.useState<boolean>(false);

    const cancellableSharePointRestApiService = React.useRef<CancellableSharePointRestApi>();

    const _selection = React.useRef(new Selection({
        onSelectionChanged: () => _getSelectionDetails()
    }));

    const _getSelectionDetails = () => {
        setSelectedItems({ items: _selection.current.getSelection(), count: _selection.current.getSelectedCount() });
    };

    const [isChannelErrorDialogHidden, setIsChannelErrorDialogHidden] = React.useState(true);

    const hideChannelErrorDialog = () => {
        setIsChannelErrorDialogHidden(true);
    }
    const showChannelErrorDialog = () => {
        setIsChannelErrorDialogHidden(false);
    }

    React.useEffect(() => {
        const columns: IColumn[] = [
            {
                key: 'locationIcon',
                name: 'Icon',
                isIconOnly: true,
                minWidth: 20,
                maxWidth: 20,
                onRender: (item: ILocation) => getLocationImage(item),
            },
            {
                key: 'locationName',
                name: languageStrings.Name,
                fieldName: 'displayName',
                minWidth: 250,
                maxWidth: 350,
                isRowHeader: true,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                data: 'string',
                onRender: (item: ILocation) => (
                    <TooltipHost content={item.description?.length > 0 ? item.description : null}>
                        {
                            getLocationLink(item)
                        }
                    </TooltipHost>
                ),
                isPadded: true,
            }
        ];

        const isTessLocation: boolean = isTessEnabled && (currentDirectory?.type === ComponentTypes.TessAccount || currentDirectory?.type === ComponentTypes.TessProject);
        const loadListsAndLibraries: boolean = !currentDirectory?.isSharedTeam && (!hideDocumentLibrariesInTeams || !currentDirectory?.teamGroupId);
        if (loadListsAndLibraries) {
            if (!isTessLocation) {
                columns.push(
                    {
                        key: 'locationRootItemCount',
                        name: languageStrings.TopLevelItems,
                        fieldName: 'rootItemCount',
                        minWidth: 80,
                        maxWidth: 80,
                        isResizable: true,
                        data: 'number',
                        onRender: (item: ILocation) => {
                            const listLocation: ISharepointListLocation = item as ISharepointListLocation;
                            if (listLocation?.rootItemCount !== undefined) {
                                return <span>{listLocation.rootItemCount}</span>;
                            }

                            if (listLocation.type === LocationType.DocumentLibrary && listLocation.isCalculatingRootItemCount) {
                                return <Spinner styles={rootLevelItemsSpinnerStyles} size={SpinnerSize.small} />;
                            }

                            return null;
                        },
                        isPadded: true,
                    }
                );
            }

            columns.push(
                {
                    key: 'locationItemCount',
                    name: languageStrings.Items,
                    fieldName: 'itemCount',
                    minWidth: 50,
                    maxWidth: 50,
                    isResizable: true,
                    data: 'number',
                    onRender: (item: ILocation) => {
                        const listLocation: ISharepointListLocation = item as ISharepointListLocation;
                        if (listLocation?.itemCount !== undefined) {
                            return <span>{listLocation.itemCount}</span>;
                        }
                        else {
                            return null;
                        }
                    },
                    isPadded: true,
                }
            );
        }

        columns.push(
            {
                key: 'locationType',
                name: "Type",
                fieldName: 'type',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                data: 'string',
                onRender: (item: ILocation) => getLocationTypeText(item),
                isPadded: true,
            },
            {
                key: 'locationCreated',
                name: languageStrings.Created,
                fieldName: 'createdDateTimeValue',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'number',
                onRender: (item: ILocation) => {
                    return <span>{item.createdDateTime}</span>;
                },
                isPadded: true,
            },
            {
                key: 'locaionModified',
                name: languageStrings.Modified,
                fieldName: 'lastModifiedDateTimeValue',
                minWidth: 70,
                isResizable: true,
                data: 'number',
                onRender: (item: ILocation) => {
                    return <span>{item.lastModifiedDateTime}</span>;
                },
                isPadded: true,
            }
        );

        setColumns(columns);

        if (currentDirectory?.siteId || currentDirectory.type === ComponentTypes.TessProject) {

            if (currentDirectory?.webUrl) {
                cancellableSharePointRestApiService.current = new CancellableSharePointRestApi(currentDirectory.webUrl);
            }

            (async () => {
                setIsLoading(true);

                try {
                    const graphAccessToken = await authModule.getGraphAccessToken();
                    let [hubSites, subSites, channels, documentLibraries, sharepointLists, allListCount, tessAccountContent, tessProjectLibsAndFolders] = await Promise.all([
                        currentDirectory.isHub && !isTessLocation ? getLocationSubSites(graphAccessToken, currentDirectory.hubId, allowedSites, true) : [],
                        !currentDirectory.isSharedTeam && !isTessLocation ? getLocationSubSites(graphAccessToken, currentDirectory.siteId, allowedSites) : [],
                        !isTessLocation ? getLocationTeamChannels(graphAccessToken, currentDirectory.teamGroupId) : [],
                        !currentDirectory.isSharedTeam && (!hideDocumentLibrariesInTeams || !currentDirectory.teamGroupId) && !isTessLocation ? getLocationDocumentLibraries(graphAccessToken, currentDirectory.siteId) : [],
                        !currentDirectory.isSharedTeam && (!hideDocumentLibrariesInTeams || !currentDirectory.teamGroupId) && !isTessLocation ? getLocationSharepointLists(graphAccessToken, currentDirectory.siteId) : [],
                        !currentDirectory.isSharedTeam && !isTessLocation ? getLists(await authModule.getSharePointAccessToken(), currentDirectory.webUrl) : [],
                        currentDirectory.type === ComponentTypes.TessAccount && currentDirectory.tessAccountId ? getLocationTessProjects(graphAccessToken, currentDirectory.tessAccountId) : null,
                        currentDirectory.type === ComponentTypes.TessProject && currentDirectory.tessAccountId && currentDirectory.tessProjectId ? getLocationTessProjectLibrariesAndFolders(graphAccessToken, currentDirectory.tessAccountId, currentDirectory.tessProjectId) : null
                    ]);

                    if (isTessLocation && (tessAccountContent?.libraries?.length > 0 || tessProjectLibsAndFolders?.libraries?.length > 0)) {
                        allListCount = await getLists(await authModule.getSharePointAccessToken(), tessAccountContent?.libraries?.length > 0 ? tessAccountContent.libraries[0].siteUrl : tessProjectLibsAndFolders.libraries[0].siteUrl);
                    }

                    const groups: IGroup[] = [];
                    const hubAssociatedHubs = hubSites?.filter(site => site.isHub);

                    let nextGroupStartIndex: number = 0;

                    if (hubAssociatedHubs?.length > 0) {
                        groups.push({ key: 'hubAssociatedHubsGroup', name: languageStrings.HubAssociatedHubs, startIndex: nextGroupStartIndex, count: hubAssociatedHubs.length, level: 0 });
                        nextGroupStartIndex += hubAssociatedHubs.length;
                    }
                    const hubAssociatedSites = hubSites?.filter(site => !site.isHub);
                    if (hubAssociatedSites?.length > 0) {
                        groups.push({ key: 'hubAssociatedSitesGroup', name: languageStrings.HubAssociatedSites, startIndex: nextGroupStartIndex, count: hubAssociatedSites.length, level: 0 });
                        nextGroupStartIndex += hubAssociatedSites.length;
                    }
                    if (subSites?.length > 0) {
                        groups.push({ key: 'subSitesGroup', name: languageStrings.Subsites, startIndex: nextGroupStartIndex, count: subSites.length, level: 0 });
                        nextGroupStartIndex += subSites.length;
                    }
                    if (channels?.length > 0) {
                        groups.push({ key: 'channelsGroup', name: languageStrings.Channels, startIndex: nextGroupStartIndex, count: channels.length, level: 0 });
                        nextGroupStartIndex += channels.length;

                        // Cache Private/Shared channel drive info
                        if (currentDirectory?.teamGroupId && currentDirectory?.teamDriveId) {
                            getTeamChannelRelatedSitesInfo(currentDirectory.teamGroupId, currentDirectory.teamDriveId, channels);
                        }
                    }
                    const folders = tessAccountContent?.folders ?? tessProjectLibsAndFolders?.folders ?? [];
                    if (folders.length > 0) {
                        groups.push({ key: 'tessProjectFolders', name: languageStrings.TessFolders, startIndex: nextGroupStartIndex, count: folders.length, level: 0 });
                        nextGroupStartIndex += folders.length;
                    }

                    documentLibraries = documentLibraries
                        .concat(tessAccountContent?.libraries ?? [])
                        .concat(tessProjectLibsAndFolders?.libraries ?? []);
                    if (documentLibraries?.length > 0) {
                        const sites: SiteItem[] = siteInfo?.filter(site => site.displayName?.trim().toLowerCase() === currentDirectory?.siteDisplayName?.trim().toLowerCase());
                        const hiddenDocumentLibraries: documentLibraryItem[] = sites?.length > 0 ? sites[0]?.documentLibraries?.filter(docLib => docLib.hidden === true) : [];
                        documentLibraries = documentLibraries.filter(docLib => !hiddenDocumentLibraries.some(hiddenLib => hiddenLib?.title?.trim().toLowerCase() === docLib?.displayName?.trim().toLowerCase()));
                        groups.push({ key: 'documentLibrariesGroup', name: languageStrings.DocumentLibraries, startIndex: nextGroupStartIndex, count: documentLibraries.length, level: 0 });
                        nextGroupStartIndex += documentLibraries.length;

                        setSharepointListLocationItemCount(allListCount, documentLibraries);
                    }

                    let activeProjects: ITessProjectLocation[] = [];
                    let draftProjects: ITessProjectLocation[] = [];
                    let finishedProjects: ITessProjectLocation[] = [];
                    if (tessAccountContent?.projects?.length > 0) {
                        activeProjects = tessAccountContent.projects.filter(p => p.status === TessProjectStatusEnum.Active);
                        if (activeProjects.length > 0) {
                            groups.push({ key: 'activeProjects', name: languageStrings.TessActiveProjects, startIndex: nextGroupStartIndex, count: activeProjects.length, level: 0 });
                            nextGroupStartIndex += activeProjects.length;
                        }

                        draftProjects = tessAccountContent.projects.filter(p => p.status === TessProjectStatusEnum.Draft);
                        if (draftProjects.length > 0) {
                            groups.push({ key: 'draftProjects', name: languageStrings.TessConceptProjects, startIndex: nextGroupStartIndex, count: draftProjects.length, level: 0 });
                            nextGroupStartIndex += draftProjects.length;
                        }

                        finishedProjects = tessAccountContent.projects.filter(p => p.status === TessProjectStatusEnum.Finished);
                        if (finishedProjects.length > 0) {
                            groups.push({ key: 'finishedProjects', name: languageStrings.TessCompletedProjects, startIndex: nextGroupStartIndex, count: finishedProjects.length, level: 0 });
                            nextGroupStartIndex += finishedProjects.length;
                        }
                    }

                    if (sharepointLists?.length > 0) {
                        groups.push({ key: 'sharepointListsGroup', name: languageStrings.Lists, startIndex: nextGroupStartIndex, count: sharepointLists.length, level: 0 });

                        setSharepointListLocationItemCount(allListCount, sharepointLists, true);
                    }

                    setHubAssociatedHubs(hubAssociatedHubs);
                    setHubAssociatedSites(hubAssociatedSites);
                    setSubSites(subSites);
                    setChannels(channels);

                    setDocumentLibraries(documentLibraries);
                    if (!isTessLocation && documentLibraries?.length > 0 && currentDirectory?.webUrl) {
                        updateSharepointLibraryRootFolderCount(currentDirectory.webUrl, documentLibraries);
                    }

                    setSharepointLists(sharepointLists);
                    setTessActiveProjectSites(activeProjects);
                    setTessDraftProjectSites(draftProjects);
                    setTessFinishedProjectSites(finishedProjects);
                    setTessProjectFolders(folders);

                    setItems([
                        ...hubAssociatedHubs,
                        ...hubAssociatedSites,
                        ...subSites,
                        ...channels,
                        ...folders,
                        ...documentLibraries,
                        ...activeProjects,
                        ...draftProjects,
                        ...finishedProjects,
                        ...sharepointLists]);
                    setGroups(groups);
                } catch (error) {
                    logger(error, "ContentBodyLibraries.tsx (LoadSiteContent)");
                }

                setIsLoading(false);
            })();
        }

        return () => {
            if (currentDirectory?.webUrl) {
                cancellableSharePointRestApiService.current.cancel(currentDirectory.webUrl);
            }
        };
    }, [currentDirectory?.siteId, currentDirectory?.tessProjectId, refresh]);

    React.useEffect(() => {
        (async () => {
            if (selectedItems?.count === 1) {
                let isLocationPinned: boolean = false;
                const selectedItem: ILocation = selectedItems.items[0];

                switch (selectedItem.type) {
                    case LocationType.HubSite:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;

                    case LocationType.SubSite:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;

                    case LocationType.TeamChannel:
                        setSelectedSharepointListId(null);
                        const teamItem = selectedItem as ITeamChannelLocation;
                        const cachedChannel = channels.find(channel => channel.id === teamItem.id) as ITeamChannelLocation;
                        if (!cachedChannel?.driveInfo) {
                            setIsTeamChannelInfoLoading(true);
                            const teamChannelInfo = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });

                            const channelsCopy = channels.slice();
                            for (const channel of channelsCopy) {
                                if (channel.id === teamItem.id) {
                                    (channel as ITeamChannelLocation).driveInfo = teamChannelInfo;
                                    break;
                                }
                            }
                            setChannels(channelsCopy);

                            isLocationPinned = pinnedItems && isFolderPinned(teamChannelInfo.driveId, teamChannelInfo.driveItemId, pinnedItems);
                            setIsTeamChannelInfoLoading(false);
                        }
                        else {
                            isLocationPinned = pinnedItems && isFolderPinned(cachedChannel.driveInfo.driveId, cachedChannel.driveInfo.driveItemId, pinnedItems);
                        }
                        break;

                    case LocationType.DocumentLibrary:
                        const documentLibraryItem = selectedItem as ISharepointListLocation;
                        setSelectedSharepointListId(documentLibraryItem.sharePointListId);
                        isLocationPinned = pinnedItems && isFolderPinned(documentLibraryItem.id, null, pinnedItems);
                        break;

                    case LocationType.SharepointList:
                        const sharepointListItem = selectedItem as ISharepointListLocation;
                        setSelectedSharepointListId(sharepointListItem.sharePointListId);
                        isLocationPinned = pinnedItems && isFolderPinned(sharepointListItem.id, null, pinnedItems);
                        break;

                    case LocationType.TessProject:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;

                    case LocationType.Folder:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;
                }

                setSelectedLocation({ ...selectedItem, isPinned: isLocationPinned });
            }
            else {
                setSelectedLocation(null);
                setSelectedSharepointListId(null);
            }
        })();
    }, [pinnedItems, selectedItems, currentDirectory?.webUrl]);

    React.useEffect(() => {
        const items: ICommandBarItemProps[] = allowOpenInSharePoint && (selectedLocation || currentDirectory?.webUrl)
            ? [
                {
                    key: "open",
                    disabled: isTeamChannelInfoLoading,
                    text: `${languageStrings.OpenIn} SharePoint`,
                    iconProps: openInBrowserIconProps,
                    onClick: openLocationInBrowser,
                    onRenderIcon: (isTeamChannelInfoLoading ? () => { return <Spinner size={SpinnerSize.small} style={{ paddingLeft: 3, paddingRight: 5 }} /> } : undefined)
                }
            ]
            : [];

        if (selectedLocation) {
            items.push({
                key: "pinUnpin",
                disabled: selectedLocation == null || isTeamChannelInfoLoading,
                text: selectedLocation?.isPinned ? languageStrings.UnpinFolder : languageStrings.PinThisFolder,
                iconProps: selectedLocation?.isPinned ? unpinIconProps : pinIconProps,
                onClick: pinUnpinLocation,
                onRenderIcon: (isTeamChannelInfoLoading ? () => { return <Spinner size={SpinnerSize.small} style={{ paddingLeft: 3, paddingRight: 5 }} /> } : undefined)
            });

            if (selectedSharepointListId && tenantEnablePermissionManagement) {
                items.push({
                    key: "libraryPermissions",
                    text: languageStrings.LibraryPermissions,
                    iconProps: permissionsIconProps,
                    onClick: () => {
                        setIsPermissionsPanelOpen(true);
                    },
                });
            }
        }
        else if (tenantEnablePermissionManagement) {
            items.push({
                key: "permissions",
                text: languageStrings.SitePermissions,
                iconProps: permissionsIconProps,
                onClick: () => {
                    setIsPermissionsPanelOpen(true);
                },
            });
        }

        setCommandItems(items);

        const farItems: ICommandBarItemProps[] = [
            // {
            //     key: "advancedSearch",
            //     iconProps: advancedSearchIconProps,
            //     iconOnly: true,
            //     tooltipHostProps: {
            //         content: languageStrings.AdvancedSearch,
            //     },
            //     onClick: () => {
            //         // logMessage("Content manager Advanced search clicked", "Click");
            //         dispatch(setMode(ModeEnum.contentManagerAdvancedSearch));
            //     }
            // },
            {
                key: "refresh",
                iconProps: refreshIconProps,
                iconOnly: true,
                tooltipHostProps: {
                    content: languageStrings.Refresh,
                },
                onClick: () => {
                    setRefresh(currentValue => !currentValue);
                }
            },
        ];

        setCommandFarItems(farItems);
    }, [currentDirectory?.webUrl, tenantEnablePermissionManagement, selectedLocation, isTeamChannelInfoLoading, selectedSharepointListId, currentDirectory.type]);

    const openLocationInBrowser = React.useCallback((ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
        if (!selectedLocation) {
            window.open(currentDirectory.webUrl);
        }
        else {
            (async () => {
                switch (selectedLocation.type) {
                    case LocationType.HubSite:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.SubSite:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.TeamChannel:
                        const teamItem = selectedLocation as ITeamChannelLocation;
                        const cachedChannel = channels.find(channel => channel.id === teamItem.id) as ITeamChannelLocation;
                        if (!cachedChannel?.driveInfo) {
                            setIsTeamChannelInfoLoading(true);
                            const teamChannelInfo: ITeamChannelDocumentLibrary = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });
                            if (!teamChannelInfo) {
                                setIsTeamChannelInfoLoading(false);
                                showChannelErrorDialog();
                                break;
                            }
                            cachedChannel.driveInfo = teamChannelInfo;
                            setIsTeamChannelInfoLoading(false);
                        }
                        window.open(cachedChannel.driveInfo.driveItemWebUrl);
                        break;

                    case LocationType.DocumentLibrary:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.SharepointList:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.TessProject:
                        const project: ITessProjectLocation = selectedLocation as ITessProjectLocation;
                        if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
                            const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
                            if (siteHit) {
                                window.open(siteHit.resource.webUrl);
                            }
                        }
                        break;

                    case LocationType.Folder:
                        window.open(selectedLocation.webUrl);
                        break;
                }
            })();
        }
    }, [currentDirectory?.webUrl, selectedLocation]);

    const pinUnpinLocation = React.useCallback((ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
        (async () => {
            const accountId: string = (await authModule.getAccount())?.accountId;
            let locations: IPageSettings[];
            let driveId: string;
            let itemId: string;
            let folderTypeIcon: FolderTypeIconEnum;
            let webUrl: string;
            let sharePointListId: string;
            let parentSiteId: string;
            let tessAccountId: string;
            let tessProjectId: string;

            switch (selectedLocation.type) {
                case LocationType.HubSite:
                    itemId = selectedLocation.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointHubSite;
                    webUrl = selectedLocation.webUrl;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                type: ComponentTypes.SharePointDocuments,
                                siteId: selectedLocation.id,
                                siteDisplayName: selectedLocation.displayName,
                                webUrl: selectedLocation.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: selectedLocation.displayName
                            }]
                        ];
                    }
                    break;

                case LocationType.SubSite:
                    itemId = selectedLocation.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointSite;
                    webUrl = selectedLocation.webUrl;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                type: ComponentTypes.SharePointDocuments,
                                siteId: selectedLocation.id,
                                siteDisplayName: selectedLocation.displayName,
                                webUrl: selectedLocation.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: selectedLocation.displayName
                            }]
                        ];
                    }
                    break;

                case LocationType.TeamChannel:
                    const teamItem = selectedLocation as ITeamChannelLocation;
                    const cachedChannel = channels.find(channel => channel.id === teamItem.id) as ITeamChannelLocation;
                    if (!cachedChannel?.driveInfo) {
                        setIsTeamChannelInfoLoading(true);
                        const teamChannelInfo: ITeamChannelDocumentLibrary = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });
                        if (!teamChannelInfo) {
                            setIsTeamChannelInfoLoading(false);
                            showChannelErrorDialog();
                            break;
                        }
                        cachedChannel.driveInfo = teamChannelInfo;
                        setIsTeamChannelInfoLoading(false);
                    }

                    driveId = cachedChannel.driveInfo.driveId;
                    itemId = cachedChannel.driveInfo.driveItemId;
                    folderTypeIcon = FolderTypeIconEnum.teamChannel;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                id: teamItem.isShared ? driveId : itemId,
                                parentId: teamItem.isShared ? null : driveId,
                                fileTitle: teamItem.displayName,
                                displayName: teamItem.displayName,
                                siteId: currentDirectory.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                type: ComponentTypes.SharePointFolders,
                                directory: getRelativeDocumentUrl(cachedChannel.driveInfo.driveItemWebUrl, teamItem.isShared),
                                DocumentLibrary: cachedChannel.driveInfo.documentLibraryName,
                                isTeamsRootFolder: true,
                                isTeamsFolder: true,
                                isSharedTeamsChannel: teamItem.isShared,
                                sharePointListId: cachedChannel.driveInfo.sharePointListId,
                                webUrl: cachedChannel.driveInfo.sharePointSiteUrl,
                                teamChannelId: teamItem.id
                            }]
                        ];
                    }
                    break;

                case LocationType.DocumentLibrary:
                    const documentLibraryItem = selectedLocation as ISharepointListLocation;

                    driveId = documentLibraryItem.id;
                    folderTypeIcon = FolderTypeIconEnum.documentLibrary;
                    webUrl = documentLibraryItem.webUrl;
                    sharePointListId = documentLibraryItem.sharePointListId;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                fileTitle: documentLibraryItem.displayName,
                                displayName: documentLibraryItem.displayName,
                                webUrl: currentDirectory.webUrl,
                                siteId: currentDirectory.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                id: documentLibraryItem.id,
                                parentId: null,
                                type: ComponentTypes.SharePointFolders,
                                directory: !currentDirectory.directory ? (documentLibraryItem.webUrl ? `${getLastSplittedStringItem(documentLibraryItem.webUrl, /[\s/]+/)}` : documentLibraryItem.displayName) : `${currentDirectory.directory}/${documentLibraryItem.displayName}`,
                                DocumentLibrary: currentDirectory.DocumentLibrary?.length > 0 ? currentDirectory.DocumentLibrary : documentLibraryItem.displayName,
                                isTeamsFolder: false,
                                isTeamsRootFolder: false,
                                sharePointListId: documentLibraryItem.sharePointListId,
                            }]
                        ];
                    }
                    break;

                case LocationType.SharepointList:
                    const sharepointListItem = selectedLocation as ISharepointListLocation;

                    driveId = sharepointListItem.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointList;
                    webUrl = sharepointListItem.webUrl;
                    sharePointListId = sharepointListItem.sharePointListId;

                    if (!currentDirectory.siteId) {
                        const site = workingDirectories.filter(x => x.siteId).slice(-1)[0] as IPageSettings;
                        parentSiteId = site.siteId;
                    }

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                fileTitle: sharepointListItem.displayName,
                                displayName: sharepointListItem.displayName,
                                webUrl: currentDirectory.webUrl,
                                siteId: currentDirectory.siteId ? currentDirectory.siteId : parentSiteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                id: sharepointListItem.id,
                                parentId: null,
                                type: ComponentTypes.SharePointList,
                                directory: !currentDirectory.directory ? (sharepointListItem.webUrl ? `${getLastSplittedStringItem(sharepointListItem.webUrl, /[\s/]+/)}` : sharepointListItem.displayName) : `${currentDirectory.directory}/${sharepointListItem.displayName}`,
                                DocumentLibrary: currentDirectory.DocumentLibrary?.length > 0 ? currentDirectory.DocumentLibrary : sharepointListItem.displayName,
                                isTeamsFolder: false,
                                isTeamsRootFolder: false,
                                sharePointListId: sharepointListItem.sharePointListId,
                            }]
                        ];
                    }
                    break;

                case LocationType.TessProject:
                    itemId = selectedLocation.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointSite;

                    if (!selectedLocation.isPinned) {
                        const project: ITessProjectLocation = selectedLocation as ITessProjectLocation;
                        if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
                            const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
                            if (siteHit) {
                                webUrl = siteHit.resource.webUrl;
                            }
                        }

                        tessAccountId = workingDirectories.find(x => x.tessAccountId)?.tessAccountId;
                        tessProjectId = project.tessProjectId;

                        locations = [
                            ...workingDirectories,
                            ...[{
                                type: ComponentTypes.TessProject,
                                siteDisplayName: selectedLocation.displayName,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: selectedLocation.displayName,
                                tessAccountId,
                                tessProjectId
                            }]
                        ];
                    }
                    break;

                case LocationType.Folder:
                    const sharepointFolderItem = selectedLocation as ISharepointFolderLocation;

                    itemId = sharepointFolderItem.id;
                    driveId = sharepointFolderItem.driveId;
                    folderTypeIcon = FolderTypeIconEnum.sharepointFolder;
                    sharePointListId = sharepointFolderItem.sharePointListId;
                    let siteDisplayName: string;

                    if (!selectedLocation.isPinned) {
                        const project: ITessProjectLocation = selectedLocation as ITessProjectLocation;
                        if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
                            const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
                            if (siteHit) {
                                webUrl = siteHit.resource.webUrl;
                                parentSiteId = siteHit.resource.id;
                                siteDisplayName = siteHit.resource.displayName;
                            }
                        }

                        const accessToken = await authModule.getGraphAccessToken();
                        const documentLibraryData = await getItemCustomSelect(accessToken, driveId, null, "id,name,webDavUrl");

                        if (documentLibraryData) {
                            locations = [
                                ...workingDirectories,
                                ...[{
                                    fileTitle: documentLibraryData.name,
                                    displayName: documentLibraryData.name,
                                    webUrl: webUrl,
                                    siteId: parentSiteId,
                                    siteDisplayName: siteDisplayName,
                                    id: documentLibraryData.id,
                                    type: ComponentTypes.SharePointFolders,
                                    directory: tryGetSiteRelativeUrl(webUrl, tryDecodeUriComponent(new URL(documentLibraryData.webDavUrl).pathname)),
                                    DocumentLibrary: documentLibraryData.name,
                                    sharePointListId: sharePointListId
                                }],
                                ...[{
                                    id: sharepointFolderItem.id,
                                    parentId: sharepointFolderItem.driveId,
                                    type: ComponentTypes.SharePointFolders,
                                    siteId: parentSiteId,
                                    siteDisplayName: siteDisplayName,
                                    webUrl: webUrl,
                                    fileTitle: sharepointFolderItem.displayName,
                                    directory: tryGetSiteRelativeUrl(sharepointFolderItem.webUrl, sharepointFolderItem.path),
                                    DocumentLibrary: documentLibraryData?.name,
                                    displayName: sharepointFolderItem.displayName,
                                    isTeamsFolder: false,
                                    sharePointListId: sharepointFolderItem.sharePointListId,
                                    contentTypeId: sharepointFolderItem.contentTypeId,
                                    serverRelativePath: sharepointFolderItem.path,
                                    sharePointUniqueId: sharepointFolderItem.sharePointUniqueId
                                }]
                            ];
                        }
                    }
                    break;
            }

            if (selectedLocation.isPinned) {
                dispatch(removePinnedItem(accountId, { driveId: driveId, itemId: itemId }, FileTypeEnum.folder));
            }
            else {
                const pinItem: IStoreItem = {
                    driveId: driveId,
                    locations: [...locations],
                    name: selectedLocation.displayName,
                    itemId: itemId,
                    fileType: FileTypeEnum.folder,
                    folderTypeIcon: folderTypeIcon,
                    datePinned: new Date(),
                    folderId: itemId,
                    webUrl: webUrl,
                    sharePointListId: sharePointListId,
                    siteId: parentSiteId ? parentSiteId : currentDirectory.siteId,
                    tessAccountId,
                    tessProjectId
                };
                dispatch(addPinnedItem(accountId, pinItem));
            }
        })();
    }, [selectedLocation]);

    const getLocationImage = React.useCallback((item: ILocation): JSX.Element => {
        switch (item.type) {
            case LocationType.HubSite:
                return <FontIcon iconName="SharepointLogo" className={gridFontIconStyles} />

            case LocationType.SubSite:
                return <img
                    src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/sharepoint_20x1.svg"
                    width="20"
                    height="20"
                    alt="SharePoint subsite icon"
                />;

            case LocationType.TeamChannel:
                return <img
                    src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/teams_20x1.svg"
                    width="20"
                    height="20"
                    alt="Team channel icon"
                />;

            case LocationType.DocumentLibrary:
                return <DocLibraryIcon className={classNames.svgIcon} />

            case LocationType.SharepointList:
                return <Icon
                    {...getFileTypeIconProps({
                        type: FileIconType.list,
                        size: 20,
                        imageFileType: "svg",
                    })}
                />

            case LocationType.TessProject:
                return <img
                    src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/sharepoint_20x1.svg"
                    width="20"
                    height="20"
                    alt="SharePoint subsite icon"
                />;

            case LocationType.Folder:
                return <Icon
                    {...getFileTypeIconProps({
                        type: FileIconType.folder,
                        size: 20,
                        imageFileType: "svg",
                    })}
                />

            default:
                return <Icon />;
        }
    }, []);

    const browseDocumentLibraryOrFolder = async (item: ILocation) => {
        try {
            const documentLibraryItem = item as ISharepointListLocation;
            if (documentLibraryItem.contentTypeId === SharePointFolderContentTypeIds.folder) {
                const folderItem = item as ISharepointFolderLocation;
                const accessToken = await authModule.getGraphAccessToken();
                const documentLibraryData = await getItemCustomSelect(accessToken, folderItem.driveId, null, "id,name");
                const folderToAdd: IPageSettings = {
                    id: folderItem.id,
                    parentId: folderItem.driveId,
                    type: ComponentTypes.SharePointFolders,
                    siteId: workingDirectories.find(x => x.siteId)?.siteId,
                    siteDisplayName: workingDirectories.find(x => x.siteDisplayName)?.siteDisplayName,
                    webUrl: folderItem.siteUrl,
                    fileTitle: folderItem.displayName,
                    directory: tryGetSiteRelativeUrl(folderItem.webUrl, folderItem.path),
                    DocumentLibrary: documentLibraryData?.name,
                    displayName: folderItem.displayName,
                    isTeamsFolder: false,
                    sharePointListId: folderItem.sharePointListId,
                    contentTypeId: folderItem.contentTypeId,
                    serverRelativePath: folderItem.path,
                    sharePointUniqueId: folderItem.sharePointUniqueId
                };
                dispatch(addWorkingDirectory(folderToAdd));
            }
            else {
                const itemToAdd: IPageSettings = {
                    id: item.id,
                    type: ComponentTypes.SharePointFolders,
                    siteId: currentDirectory.siteId,
                    siteDisplayName: currentDirectory.siteDisplayName,
                    webUrl: documentLibraryItem.siteUrl || currentDirectory.webUrl,
                    fileTitle: documentLibraryItem.displayName,
                    directory: documentLibraryItem.siteUrl && documentLibraryItem.webUrl
                        ? documentLibraryItem.webUrl.replace(documentLibraryItem.siteUrl, "")
                        : getLastSplittedStringItem(documentLibraryItem.webUrl, /[\s/]+/),
                    DocumentLibrary: documentLibraryItem.displayName,
                    displayName: documentLibraryItem.displayName,
                    isTeamsFolder: currentDirectory.isTeamsFolder,
                    sharePointListId: documentLibraryItem.sharePointListId
                };

                const sharepointListItemIndex = workingDirectories.findIndex(x => x.sharePointListId);
                if (sharepointListItemIndex === -1) {
                    dispatch(addWorkingDirectory(itemToAdd));
                } else {
                    dispatch(removeDirectoriesByIndexAndAddItem(sharepointListItemIndex, itemToAdd));
                }
            }
        } catch (error) {
            logger(error, "ContentBodyLibraries.tsx (browseDocumentLibraryOrFolder)");
        }
    }

    const getLocationLink = React.useCallback((item: ILocation): JSX.Element => {
        try {
            switch (item.type) {
                case LocationType.HubSite:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const itemToAdd: IPageSettings = {
                                type: ComponentTypes.SharePointDocuments,
                                siteId: item.id,
                                siteDisplayName: item.displayName,
                                webUrl: item.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: item.displayName,
                                isHub: item.isHub,
                                hubId: item.hubId,
                                parentHubId: item.parentHubId
                            };
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.SubSite:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const itemToAdd: IPageSettings = {
                                type: ComponentTypes.SharePointDocuments,
                                siteId: item.id,
                                siteDisplayName: item.displayName,
                                webUrl: item.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: item.displayName,
                                tessProjectId: item.tessProjectId
                            };
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.TeamChannel:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={async () => {
                            dispatch(setIsContentManagerContentLoading(true));
                            const teamItem = item as ITeamChannelLocation;
                            const teamChannelInfo = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });
                            if (!teamChannelInfo) {
                                dispatch(setIsContentManagerContentLoading(false));
                                showChannelErrorDialog();
                                return;
                            }
                            const itemToAdd: IPageSettings = {
                                id: teamItem.isShared ? teamChannelInfo.driveId : teamChannelInfo.driveItemId,
                                parentId: teamItem.isShared ? null : teamChannelInfo.driveId,
                                type: ComponentTypes.SharePointFolders,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                webUrl: teamChannelInfo.sharePointSiteUrl,
                                fileTitle: teamItem.displayName,
                                directory: getRelativeDocumentUrl(teamChannelInfo.driveItemWebUrl, teamItem.isShared),
                                DocumentLibrary: teamChannelInfo.documentLibraryName,
                                displayName: teamItem.displayName,
                                isTeamsRootFolder: true,
                                isTeamsFolder: currentDirectory.isTeamsFolder,
                                isSharedTeamsChannel: teamItem.isShared,
                                sharePointListId: teamChannelInfo.sharePointListId,
                                teamChannelId: teamItem.id
                            };
                            dispatch(setIsContentManagerContentLoading(false));
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        <Stack horizontal verticalAlign="center" tokens={gridLinkStackTokens}>
                            <span>{item.displayName}</span>
                            {(item as ITeamChannelLocation)?.isPrivate && <ChannelPrivateIcon />}
                            {(item as ITeamChannelLocation)?.isShared && <ChannelShareIcon />}
                        </Stack>
                    </Link>

                case LocationType.DocumentLibrary:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            browseDocumentLibraryOrFolder(item);
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.SharepointList:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const sharepointListItem = item as ISharepointListLocation;

                            const itemToAdd: IPageSettings = {
                                id: item.id,
                                type: ComponentTypes.SharePointList,
                                siteId: currentDirectory.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                webUrl: currentDirectory.webUrl,
                                fileTitle: sharepointListItem.displayName,
                                directory: getLastSplittedStringItem(sharepointListItem.webUrl, /[\s/]+/),
                                sharepointList: sharepointListItem.displayName,
                                displayName: sharepointListItem.displayName,
                                isTeamsFolder: currentDirectory.isTeamsFolder,
                                sharePointListId: sharepointListItem.sharePointListId
                            };

                            const sharepointListItemIndex = workingDirectories.findIndex(x => x.sharePointListId);
                            if (sharepointListItemIndex === -1) {
                                dispatch(addWorkingDirectory(itemToAdd));
                            } else {
                                dispatch(removeDirectoriesByIndexAndAddItem(sharepointListItemIndex, itemToAdd));
                            }
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.TessProject:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const itemToAdd: IPageSettings = {
                                type: ComponentTypes.TessProject,
                                siteDisplayName: item.displayName,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: item.displayName,
                                tessAccountId: workingDirectories.find(x => x.tessAccountId)?.tessAccountId,
                                tessProjectId: item.tessProjectId
                            };
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.Folder:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={async () => {
                            dispatch(setIsContentManagerContentLoading(true));
                            browseDocumentLibraryOrFolder(item);
                            dispatch(setIsContentManagerContentLoading(false));
                        }}
                    >
                        {item.displayName}
                    </Link>

                default:
                    return <Label>{item.displayName}</Label>;
            }
        } catch (error) {
            logger(error, "ContentBodyLibraries.tsx (getLocationLink)");
            return <Label>{item.displayName}</Label>;
        }
    }, [currentDirectory]);

    const getLocationTypeText = React.useCallback((item: ILocation): JSX.Element => {
        switch (item.type) {
            case LocationType.HubSite:
                return <span>{languageStrings.HubSite}</span>;

            case LocationType.SubSite:
                return <span>{"Subsite"}</span>;

            case LocationType.TeamChannel:
                return <span>{"Team channel"}</span>;

            case LocationType.DocumentLibrary:
                return <span>{languageStrings.DocumentLibrary}</span>;

            case LocationType.SharepointList:
                return <span>{languageStrings.List}</span>;

            case LocationType.TessProject:
                return <span>{"Project"}</span>;

            default:
                return <span />;
        }
    }, []);

    const setSharepointListLocationItemCount = React.useCallback((allListCount: IListInfo[], locations: ISharepointListLocation[], syncTopLevelCount: boolean = false): void => {
        if (allListCount?.length > 0) {
            locations.forEach(location => {
                const list: IListInfo = allListCount.find(list => list.Id === location.sharePointListId);
                if (list) {
                    const listItemCount: number = list.ItemCount;
                    location.itemCount = listItemCount;
                    if (syncTopLevelCount || listItemCount === 0) {
                        location.rootItemCount = listItemCount;
                    }
                }
            });
        }
    }, []);

    const updateSharepointLibraryRootFolderCount = React.useCallback(async (webUrl: string, locations: ISharepointListLocation[]): Promise<void> => {
        if (locations?.filter(location => location.itemCount > 0)?.length > 0) {
            const timeout = setTimeout(() => {
                if (!cancellableSharePointRestApiService.current.getIsCancellationRequested(webUrl)) {
                    for (let l = 0; l < locations.length; l++) {
                        if (locations[l].rootItemCount === undefined) {
                            locations[l].isCalculatingRootItemCount = true;
                        }
                    }
                    setDocumentLibraries([...locations]);
                }
            }, 1000);

            for (let i = 0; i < locations.length; i += 20) {
                const locationsSlices: ISharepointListLocation[] = locations.slice(i, i + 20);

                await Promise.all(locationsSlices.map(async location => {
                    if (location.itemCount > 0) {
                        if (!cancellableSharePointRestApiService.current.getIsCancellationRequested(webUrl)) {
                            let rootItemCount: number = await cancellableSharePointRestApiService.current.getSharepointLibraryRootItemCount(webUrl, location.sharePointListId);
                            if (rootItemCount > location.itemCount) {
                                rootItemCount = location.itemCount;
                            }
                            location.rootItemCount = rootItemCount;
                            location.isCalculatingRootItemCount = false;

                            if (!cancellableSharePointRestApiService.current.getIsCancellationRequested(webUrl)) {
                                setDocumentLibraries([...locations]);
                            }
                        }
                    }
                }));
            }

            clearTimeout(timeout);
        }
    }, [currentDirectory]);

    const onColumnHeaderClick = React.useCallback((ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });

        const newItems = [
            ..._copyAndSort(hubAssociatedHubs, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(hubAssociatedSites, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(subSites, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(channels, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(tessProjectFolders, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(documentLibraries, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(tessActiveProjectSites, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(tessDraftProjectSites, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(tessFinishedProjectSites, currColumn.fieldName!, currColumn.isSortedDescending),
            ..._copyAndSort(sharepointLists, currColumn.fieldName!, currColumn.isSortedDescending)
        ];
        setColumns(newColumns);
        setItems(newItems);
    }, [columns, hubAssociatedHubs, hubAssociatedSites, subSites, channels, documentLibraries, tessActiveProjectSites, tessDraftProjectSites, tessFinishedProjectSites, sharepointLists, tessProjectFolders, setColumns, setItems]);

    const channelDialogContentProps = {
        type: DialogType.largeHeader,
        title: languageStrings.TeamsChannel,
        closeButtonAriaLabel: "Close",
        subText: languageStrings.TeamsChannelNotLoaded
    };

    const channelErrorDialog = !isChannelErrorDialogHidden && (
        <Dialog hidden={false} onDismiss={hideChannelErrorDialog} dialogContentProps={channelDialogContentProps}>
            <DialogFooter>
                <PrimaryButton onClick={hideChannelErrorDialog} text="Ok" />
            </DialogFooter>
        </Dialog>
    );

    const _onRenderDetailsHeader: IDetailsListProps['onRenderDetailsHeader'] = props => {
        if (props) {
            return <DetailsHeader {...props} isAllCollapsed={groups?.length > 0 ? !groups?.some(g => !g.isCollapsed) : false} />;
        }
        return null;
    };

    const onGridItemDrop = async (item) => {
        browseDocumentLibraryOrFolder(item);
    }

    const onDragHover = async (item) => {
        browseDocumentLibraryOrFolder(item);
    }

    const _onRenderRow: IDetailsListProps['onRenderRow'] = rowProps => {
        return (
            <DraggableContainer isValidDropZone={rowProps.item.type === LocationType.DocumentLibrary || rowProps.item.type === LocationType.Folder} onDragHover={() => onDragHover(rowProps.item)} onDropBeforeFiles={() => { generalModule.setOpenPanelUploadPanel(true), setIsUploadingFiles(true) }} onDropAfterFiles={() => onGridItemDrop(rowProps.item)}>
                <DetailsRow {...rowProps} />
            </DraggableContainer>
        )
    }

    return (
        <>
            <CommandBar
                styles={commandBarStyle}
                items={commandItems}
                farItems={commandFarItems}
                ariaLabel="Use left and right arrow keys to navigate between commands"
            />
            <div className={classNames.wrapper}>
                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                    {!isUploadingFiles && <ShimmeredDetailsList
                        compact={false}
                        items={items || []}
                        columns={columns}
                        groups={groups}
                        selectionMode={SelectionMode.single}
                        constrainMode={ConstrainMode.unconstrained}
                        onRenderDetailsHeader={_onRenderDetailsHeader}
                        onColumnHeaderClick={onColumnHeaderClick}
                        onRenderRow={_onRenderRow}
                        getKey={_getKey}
                        enableShimmer={isLoading}
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                        selectionPreservedOnEmptyClick={true}
                        selection={_selection.current}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        checkButtonAriaLabel="Row checkbox"
                    />}
                    {isUploadingFiles && <ShimmeredDetailsList
                        items={[]}
                        columns={columns}
                        enableShimmer={isUploadingFiles}
                    />}
                </ScrollablePane>
            </div>
            {channelErrorDialog}
            {isAdvancedSearchPanelOpen && <CMFAdvancedSearchPanel panelIsOpen={isAdvancedSearchPanelOpen} closePanel={() => setIsAdvancedSearchPanelOpen(false)} />}
            {isPermissionsPanelOpen && <CMPermissionsPanel panelIsOpen={isPermissionsPanelOpen} closePanel={() => setIsPermissionsPanelOpen(false)} sharePointListId={selectedSharepointListId} />}
        </>
    )
};